import React, { useRef } from 'react';
import LottieTransitionLoader from './PopChild/LottieTransition'

const PreviewLottieTransition = ({ UnloadedCounter, setUnloadedCounter, LoadCounter, setLoadCounter, value, TickerStart, TickerPosition, zInd, CanvasDisplay, index, onePX }) => {

    const CharRef = useRef(null)

    return (<>
        <div className={"changer EditStart " + value.InClass + value.OutClass}
            style={{
                'VendorAnimationDuration': '.5s', transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : '',
                display: (!CanvasDisplay ? value.player ? 'inline-block' : 'none' : TickerStart ? (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ? 'inline-block' : 'none' : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' : 'none'),
                height: value.height, width: value.width, zIndex: zInd, left: value.x, top: value.y
            }}
            ref={CharRef}
        >
            <LottieTransitionLoader key={`CharacterLoader${index}`} index={index} value={value} height={value.height} width={value.width}
                player={value.Animate} ticker={TickerPosition} Setting={value.character_Setting}
                AnimationId={value.AnimationId + 'inPreview'} CanvasDisplay={CanvasDisplay} onePxEquivalent={onePX}
                UnloadedCounter={UnloadedCounter} setUnloadedCounter={setUnloadedCounter} LoadCounter={LoadCounter} setLoadCounter={setLoadCounter} />
        </div>
    </>);
};


export default PreviewLottieTransition;